//last version
//new version 2025-12-23

class DatabaseInterfaceController {
    private appContext: any;
    constructor(ctx: any) {
        this.appContext = ctx;
    }
    public Queue(actionMode: string, actionParams: any[]) {
        //add to queue
        this.appContext.databaseActionModeQueueRef.current = this.appContext.databaseActionModeQueueRef.current.concat(actionMode);
        this.appContext.databaseActionParamsQueueRef.current = this.appContext.databaseActionParamsQueueRef.current.concat([actionParams]);
        //update state
        this.appContext.SetDatabaseActionModeQueue([...this.appContext.databaseActionModeQueueRef.current]);
        this.appContext.SetDatabaseActionParamsQueue([...this.appContext.databaseActionParamsQueueRef.current]);
    }
    public ResetQueue(exemption?: string[]) {
        console.log('ResetQueue was called!');
        //clear none exempted actionMode
        if(exemption && exemption.length > 0) {
            this.appContext.databaseActionModeQueueRef.current.map((actionMode: string, i: number) => {
                if(!exemption.includes(actionMode)) {
                    this.appContext.databaseActionModeQueueRef.current.splice(i, 1);
                    this.appContext.databaseActionParamsQueueRef.current.splice(i, 1);
                }
            });
        } else {
            this.appContext.databaseActionModeQueueRef.current = [];
            this.appContext.databaseActionParamsQueueRef.current = [];
        }
        //update state
        this.appContext.SetDatabaseActionModeQueue([...this.appContext.databaseActionModeQueueRef.current]);
        this.appContext.SetDatabaseActionParamsQueue([...this.appContext.databaseActionParamsQueueRef.current]);  
    }
}
export default DatabaseInterfaceController;